<header>
  <h2>Warning</h2>
  <span>If you start a new chat then you will lose your previous conversation</span>
</header>
<div class="button-wrapper">
  <button class="btn btn-lrg button-grey align-items-end" (click)="onReturnToPreviousChatbotState()">Return</button>
  <button class="btn btn-lrg button-red align-items-end" (click)="onProceedToNewChatState()">Proceed</button>
</div>
